import type { DailyTacticalReadiness } from '../../services/operationsApi';

export default function Atu2CohortPanel({ readiness }: Props) {
  const rows = [
    ['공식 관찰 기록', readiness.official_cohort_id, readiness.cohorts.official_run_count, '4-8주 공식 관찰 기간에 포함되는 기록입니다.'],
    ['사전 리허설 기록', readiness.rehearsal_cohort_id, readiness.cohorts.rehearsal_run_count, '공식 시작 전 실제 모델과 근거 저장을 검증합니다.'],
    ['연결 확인 기록', readiness.plumbing_cohort_id, readiness.cohorts.plumbing_run_count, 'HOLD-only 배관 테스트이며 성과 판정에 쓰지 않습니다.'],
  ] as const;
  return (
    <section className="atu2-panel">
      <div className="atu2-section-head">
        <div>
          <span className="atu2-kicker">기록 묶음</span>
          <h2>어떤 기록이 어디에 쌓였나</h2>
        </div>
        <p>cohort는 같은 조건으로 만든 실험 기록 묶음입니다.</p>
      </div>
      <div className="atu2-cohort-list">
        {rows.map(([label, internal, count, note]) => (
          <article key={internal} className="atu2-cohort-row">
            <div><strong>{label}</strong><code>{internal}</code></div>
            <span>{count}건</span>
            <p>{note}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

type Props = {
  readiness: DailyTacticalReadiness;
};
